export default __webpack_public_path__ + "static/media/EditLight.3302fe81.svg";